import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { LANGUAGE } from "common/viewContent";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns, { selectRow } from "./Columns";
import AddModal from "components/Modals/AddLanguage";
import ViewModal from "components/Modals/LanguageJsonModal";
import inputFields from "./inputFields";
import Validation from "./Validation";
import {
  addLanguage,
  editLanguage,
  getLanguageList,
  getLanguagesCode,
  deleteLanguage,
} from "store/language/actions";

const List = () => {
  const dispatch = useDispatch();
  const { langList, loading, languageCodes } = useSelector(
    (state) => state.Language,
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [languageCode, setLanguageCode] = useState("");
  const [addModalShow, setAddModalShow] = useState(false);
  const [jsonModalShow, setJsonModalShow] = useState(false);

  const [filter, setFilter] = useState({
    pageNo: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
  });

  const [formData, setFormData] = useState({
    locale_code: "",
  });

  useEffect(() => {
    getApiData(filter);
    setcolumns(
      Columns({ deleteHandler, handleEdit, viewHandler, handleStatus }),
    );
  }, []);

  async function getApiData(query) {
    try {
      dispatch(getLanguageList({ data: query }));
      dispatch(getLanguagesCode({}));
    } catch (error) {
      console.error(error);
    }
  }

  const handleStatus = (id, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          getApiData(filter);
          toast.success(res.message);
        }
      };

      dispatch(
        editLanguage({
          data: { _id: id, status: status },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleEdit = (info) => {
    setFormData((prev) => {
      return {
        ...prev,
        _id: info._id,
        language_name: info.language_name,
        language_native_name: info.language_native_name,
        locale_code: info.locale_code,
        language_code: info.language_code,
        flag_url: info.flag_url,
        country_code: info.country_code,
        country_name: info.country_name,
        status: info.status,
      };
    });
    setAddModalShow(true);
  };

  const handleSubmit_ = (info) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setAddModalShow(false);
          getApiData(filter);
          toast.success(res.message);
          setFormData({
            language_name: "",
            language_native_name: "",
            locale_code: "",
            language_code: "",
            flag_url: "",
            country_code: "",
            country_name: "",
            status: "",
          });
        }
      };
      if (info.hasOwnProperty("_id")) {
        dispatch(
          editLanguage({
            data: info,
            callback,
          }),
        );
      } else {
        dispatch(
          addLanguage({
            data: info,
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const deleteHandler = (id) => {
    try {
      const userConfirmed = window.confirm(
        "Are you sure, you want to delete this language?",
      );
      if (userConfirmed) {
        const callback = (err, res) => {
          if (err) {
            toast.error(err);
          } else {
            getApiData(filter);
            toast.success(res.message);
          }
        };

        dispatch(
          deleteLanguage({
            data: { _id: id },
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const viewHandler = (info) => {
    setLanguageCode(info?.language_code);
    setJsonModalShow(true);
  };

  const languageOptionsArray = languageCodes.map((obj) => {
    const key = Object.keys(obj)[0];
    const value = obj[key];
    return { value: key, label: value };
  });
  inputFields.find((field) => field.type === "dynamic_select").options =
    languageOptionsArray;

  return (
    <>
      <AddModal
        show={addModalShow}
        handleClose={() => {
          setAddModalShow(false);
          setFormData({
            language_name: "",
            language_native_name: "",
            locale_code: "",
            language_code: "",
            flag_url: "",
            country_code: "",
            country_name: "",
            status: "",
            _id: "",
          });
        }}
        title={`${formData.hasOwnProperty("_id") ? "Edit" : "Add"} Language`}
        content={""}
        handleConfirm={handleSubmit_}
        loading={loading}
        initialValues={formData}
        inputFields={inputFields}
        Validation={Validation}
        codes={languageCodes}
      />

      {jsonModalShow && (
        <ViewModal
          show={jsonModalShow}
          handleClose={() => {
            setJsonModalShow(false);
            setLanguageCode("");
          }}
          languageCode={languageCode}
        />
      )}

      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={LANGUAGE.CURRENT_MODULE} />

      <section className="section">
        <div className="section-header">
          <h1>{LANGUAGE.CURRENT_MODULE}</h1>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{LANGUAGE.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-6">
                <div className="card-header d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => setAddModalShow(true)}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          {!loading && langList?.length > 0 && (
            <Table
              data={langList}
              columns={columns}
              setFilter={setFilter}
              // total={language?.totalCount}
              // filter={filter}
              toggleConfirmModal={handleStatus}
            />
          )}
          {(!loading && langList?.length === 0) ||
            (langList?.length === 0 && (
              <p style={{ textAlign: "center" }}>No Language Found</p>
            ))}
        </div>
      </section>
    </>
  );
};

export default List;
